module.exports = __webpack_public_path__ + "img/logo_dirif.c11f7d9d.png";